import type { ReportGridFilterModel } from '@aline/common';
import { Apollo } from 'src/gql/generated';
import { useDebouncedValue } from 'src/hooks/utils';

const COUNT_DEBOUNCE_MS = 500;

/**
 * Live count of the documents the plan's filters match, so the card can say
 * how many documents the report will cover as the user edits the filters.
 * Debounced so a burst of edits fetches once. The approval card already
 * carries the canonical Report grid model, so the count query receives the
 * exact filter shape that report creation will persist.
 */
export function useMatchingDocumentCount({
  enabled,
  filterModel,
}: {
  enabled: boolean;
  filterModel: ReportGridFilterModel;
}) {
  const debouncedFilterModel = useDebouncedValue(filterModel, COUNT_DEBOUNCE_MS);
  const { data, previousData } = Apollo.useCountFilteredDocumentsQuery({
    fetchPolicy: 'network-only',
    skip: !enabled,
    variables: { filterModel: debouncedFilterModel },
  });

  return data?.countFilteredDocuments ?? previousData?.countFilteredDocuments;
}
